import ApiService from "./ApiService";

class PostponeController {
  constructor() {
    this.apiService = new ApiService();
  }

  /**
   * Get open requests for a team
   * @param {string} teamId
   * @returns {Promise<Object[]>}
   */
  async getOpenRequests(teamId) {
    return this.apiService.get(`postpone/open?teamID=${teamId}`);
  }

  /**
   * Create a new postpone request
   * @param {string} matchId
   * @param {Object} requester - { id: string, teamName: string }
   * @param {Object} requestee - { id: string, teamName: string }
   * @returns {Promise<Object>}
   */
  async createNewRequest(matchId, requester, requestee) {
    const sanitizeTeam = (team) => ({
      id: team.id || null,
      sid: team.sid || "",
      logo: team.logo || "",
      teamName: team.teamName || "",
    });

    const requestBody = {
      match: { id: matchId },
      requester: sanitizeTeam(requester),
      requestee: sanitizeTeam(requestee),
      response: null,
      status: false,
      responseDate: null,
    };

    return this.apiService.post("postpone", requestBody);
  }

  /**
   * Approve a postpone request
   * @param {string} requestId
   * @returns {Promise<Object>}
   */
  async approveRequest(requestId) {
    return this.apiService.post(`postpone/${requestId}/approve`);
  }

  /**
   * Deny a postpone request
   * @param {string} requestId
   * @returns {Promise<Object>}
   */
  async denyRequest(requestId) {
    return this.apiService.post(`postpone/${requestId}/deny`);
  }

  /**
   * Get all postpone requests where team is requester or requestee
   * @param {string} teamId
   * @returns {Promise<Object[]>}
   */
  async getTeamPostponeRequests(teamId) {
    return this.apiService.get(`postpone/team/${teamId}/all`);
  }
}

export default PostponeController;
